"use client";

import type * as React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export interface CCheckboxProps extends React.ComponentProps<typeof Checkbox> {
  className?: string;
}

/**
 * CCheckbox — Design system checkbox.
 * Wraps the shadcn Checkbox primitive and adds cursor-pointer.
 */
const CCheckbox = ({ className, ...props }: CCheckboxProps) => {
  return <Checkbox className={cn("cursor-pointer", className)} {...props} />;
};

export default CCheckbox;
export { CCheckbox };
